<div
  class="coin-chip-info"
  [ngStyle]="{ 'border-color': color }"
  [class.big]="big">
  <p
    class="title"
    [ngStyle]="{ 'background-color': color, color: textColor }">
    @if (titleIcon) {
      <mat-icon
        [ngStyle]="{ color: setIconColor ? color : 'inherit' }"
        [class.only-icon]="onlyDisplayTitleIcon">
        {{ titleIcon }}
      </mat-icon>
    }
    {{ titleText }}{{ setIndicator ? ':' : '' }}
  </p>
  <p
    #valueText
    class="value inline-break"
    [ngClass]="{ small: small, big: big }"
    [matTooltip]="!tooltip && isEllipsisActive ? value : tooltip">
    @if (icon) {
      <mat-icon
        [ngClass]="{ 'big-icon': bigIcon }"
        [ngStyle]="{ color: setIconColor ? color : 'inherit' }">
        {{ icon }}
      </mat-icon>
    }
    {{ value }}
  </p>
</div>
